import React, { Component } from 'react';
import Card from 'Utils/Cards/cardGrande';
import LoadMask from 'Utils/LoadMask/LoadMask';
import Form from './GastoForm';
import UpdateForm  from './GastoForm';
import { iconsh } from "icons";

export default class GastoCrear extends Component {
state = {
    editar: false,
    mensaje: 'Agregar Gasto',
    password: false,
}
componentWillMount(){
    if(this.props.match.params.id){
        this.props.detail(this.props.match.params.id);
        this.setState({
                editar: true,
                mensaje: 'Editar Gasto'
            });
    }
}
verPassword = () =>{
    this.setState({
        password: !this.state.password
    })
}
render() {
    const { create, update } = this.props;
    const { updateData, cargando } = this.props;
    return (
    <div className="container m-0 contenido-principal row d-flex justify-content-center">
        <div className="col-md-12">
            <Card
                icono={iconsh.crud_gastos}
                titulo={this.state.mensaje}>
                <LoadMask loading={cargando} blur_1>
                    {
                        this.state.editar ?
                            <UpdateForm
                                onSubmit={update}
                                updateData={updateData}
                                editando={true} />
                        :
                            <Form onSubmit={create}  />
                    }
                </LoadMask>
            </Card>
        </div>
    </div>
    )
    }
}
